module.exports = __webpack_public_path__ + "img/2012-12-03 13.50.89db6936.jpg";